import { PlanAdditionalPDFDetails } from "./plan-additional-pdfdetails";

export class PlanDetails {
  planId: number;
  planName: string;
  logoUploaded: string;
  urlTitleText: string;
  urlBodyText: string;
  urlColor:string;
  lastPublicationDate:string;

  planLogo: any;

  planAdditionalPDFDetailsList:Array<PlanAdditionalPDFDetails>;
  otherPDFDetailsList:Array<PlanAdditionalPDFDetails>;
  pdfDetailsList:Array<PlanAdditionalPDFDetails>;

    // First Page
    sponserName: string;
    toolFreeNumber: string;
    toolFreeTTYNumber: string;
    planHours: string;
    webAddress: string;
    marketingMaterialId: string;

    customerSetId: number;
    customerSetName: string;

    packageId: number;
    packageName: string;
    associatedToMedicare: boolean;
    effectiveFormularyPackageId: number;
    packageDateRange: string;

    fontStyle: string;

    fileEventId: string;
    fileName: string;

    introPDFUploaded: string;
    closingPDFUploaded: string;

    // Second Page
    reasonNotPricedDisplay: string;
    repackagersDisplay: string;
    obsoleteDrugDisplay: string;
    otcDrugDisplay: string;
    drugListId: number;
    drugListShortName: string;

    // Third Page
    urlRequired: string;

    urlColorSelection: string;
    urlDrugNotFoundMessage: string;
    urlDisclaimerText: string;

    urlFTProgramDetailsDisplay: string;
    urlPAProgramDetailsDisplay: string;
    urlSTProgramDetailsDisplay: string;
    urlQLProgramDetailsDisplay: string;
    urlDefaultForClassificationDisplay: string;
    externalPDFList:string[];

    // Fourth Page
    cfPostOnUrl: string;

    cfIntroPageUploaded: string;
    cfClosingPageUploaded: string;

    cfDrugFormatDisplay: string;
    cfPlanCondenseDisplay: string;

    cfBodyFontSize: string;
    cfFooterText: string;

    cfFTProgramDetailsDisplay: string;
    cfPAProgramDetailsDisplay: string;
    cfSTProgramDetailsDisplay: string;
    cfQLProgramDetailsDisplay: string;
    cfDefaultForClassificationDisplay: string;

    // Fifth Page
    requireAdditionalPDFs: string;

    drugSearchType: string;
}
